import { useUIStore } from '@/stores/useUIStore';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '@/components/ui/dialog';
import { useTranslation } from 'react-i18next';
import { CheckCircle } from 'lucide-react';
import { Button } from '@/components/ui/button';

export const ServiceDetailModal = () => {
  const { isServiceModalOpen, selectedService, closeServiceModal } = useUIStore();
  const { t } = useTranslation();

  const handleOpenChange = (isOpen: boolean) => {
    if (!isOpen) {
      closeServiceModal();
    }
  };

  if (!selectedService) {
    return null;
  }

  return (
    <Dialog open={isServiceModalOpen} onOpenChange={handleOpenChange}>
      <DialogContent className="sm:max-w-[600px] max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle className="text-2xl font-bold">{selectedService.title}</DialogTitle>
          <DialogDescription>
            {selectedService.description}
          </DialogDescription>
        </DialogHeader>
        <div className="grid gap-4 py-4">
            <div className="relative h-64 w-full rounded-lg overflow-hidden">
                <img 
                    src={selectedService.image} 
                    alt={selectedService.title} 
                    className="w-full h-full object-cover" 
                />
            </div>
          <div>
            <h4 className="font-semibold text-lg mb-2">{t('services.modal_features_title')}</h4>
            <ul className="space-y-2">
              {selectedService.features.map((feature, index) => (
                <li key={index} className="flex items-start">
                  <CheckCircle className="w-5 h-5 text-secondary-500 mr-2 mt-1 flex-shrink-0" />
                  <span>{feature}</span>
                </li>
              ))}
            </ul>
          </div>
          <div className="flex justify-center items-center bg-gray-50 p-4 rounded-lg">
            <Button asChild size="lg" className="bg-brand-turquoise text-white hover:bg-teal-700">
              <a href="#contact" onClick={closeServiceModal}>{t('services.modal_cta')}</a>
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};
